import _extends from "@babel/runtime/helpers/extends";
import { Button, Form, Input, App, Checkbox, Spin } from "antd";
import { observer } from "mobx-react";
import { useState, useCallback } from "react";
import { useRealCommerceErrorHandling } from "../../hooks";
import { IMPREZA_BUTTON_PROPS, _i, __ } from "../../utils";
import { RealCommerceError } from "../../exceptions";
import { useStores } from "../../store";
import { useNavigate } from "react-router-dom";
import { EEnvatoPurchaseStatus } from "@devowl-wp/api-real-commerce";
const CreateAccountFormLayout = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 16
  }
};

/**
 * Form to create a new account for an Envato / CodeCanyon purchase.
 */
const CreateAccountEnvatoForm = observer(() => {
  const {
    message
  } = App.useApp();
  const {
    accountStore
  } = useStores();
  const [busy, setBusy] = useState(false);
  const initialValues = {
    purchaseCode: "",
    firstName: "",
    lastName: "",
    email: "",
    terms: false,
    privacy: false
  };
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const onFinish = useCallback(async values => {
    setBusy(true);
    try {
      const {
        envatoPurchase: {
          status
        }
      } = await accountStore.createAccountEnvato(values);
      message.success(status === EEnvatoPurchaseStatus.Complete ? __("Successfully added license to your account. You can now sign in to your account!") : __("Successfully created account! Please check your inbox to activate the account."), 5);
      navigate("/");
    } catch (e) {
      if (e instanceof RealCommerceError) {
        handleRealCommerceError(e);
      }
    } finally {
      setBusy(false);
    }
  }, [history]);
  return /*#__PURE__*/React.createElement("div", {
    className: "real-commerce-create-account-form"
  }, /*#__PURE__*/React.createElement(Spin, {
    spinning: busy
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 25,
      fontWeight: "bold"
    }
  }, __("Activate codecanyon.net purchases on devowl.io")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginBottom: 10
    }
  }, __("We sell a part of our products on codecanyon.net. There you can download these products, view invoices, etc. If you prefer to do that on devowl.io, you are welcome to create a devowl.io account or add your license to an existing devowl.io account. Please fill in the following information!")), /*#__PURE__*/React.createElement(Form, _extends({
    form: form,
    onFinish: onFinish,
    initialValues: initialValues,
    labelWrap: true
  }, CreateAccountFormLayout), /*#__PURE__*/React.createElement(Form.Item, {
    name: "purchaseCode",
    label: __("Purchase code (license key)"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your purchase code!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: "firstName",
    label: __("First name"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your first name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: "lastName",
    label: __("Last name"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your last name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: "email",
    label: __("Email address"),
    rules: [{
      type: "email",
      required: true,
      message: __("Please enter a valid email address!")
    }],
    required: true
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: "terms",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the Terms and Conditions!")
    }],
    wrapperCol: {
      offset: CreateAccountFormLayout.labelCol.span
    }
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read and agree to the {{a}}Terms and Conditions{{/a}}."), {
    a: /*#__PURE__*/React.createElement("a", {
      href: __("https://devowl.io/terms/"),
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    name: "privacy",
    valuePropName: "checked",
    rules: [{
      type: "boolean",
      required: true,
      transform: value => value || undefined,
      message: __("Please confirm that you have read the privacy policy!")
    }],
    wrapperCol: {
      offset: CreateAccountFormLayout.labelCol.span
    }
  }, /*#__PURE__*/React.createElement(Checkbox, null, _i(__("I have read the {{a}}Privacy Policy{{/a}}"), {
    a: /*#__PURE__*/React.createElement("a", {
      href: __("https://devowl.io/privacy-policy/"),
      target: "_blank",
      rel: "noreferrer"
    })
  }))), /*#__PURE__*/React.createElement(Form.Item, {
    wrapperCol: {
      offset: CreateAccountFormLayout.labelCol.span
    }
  }, /*#__PURE__*/React.createElement(Button, _extends({
    type: "primary",
    size: "large",
    htmlType: "submit"
  }, IMPREZA_BUTTON_PROPS), __("Add license to devowl.io account"))))));
});
export { CreateAccountEnvatoForm };